export const applicantList = [
    {
        name:"Anik Ahmed",
        img:"./assets/images/dashboards/adminDashboard/HR/applicant_one.png",
        appliedfor:"Applied for Dotnet Developer",
        phone:"01457866223",
        mail:"abc@gmail.com"
    },
    {
        name:"Farhan Ahmed",
        img:"./assets/images/dashboards/adminDashboard/HR/applicant_two.png",
        appliedfor:"Applied for Dotnet Developer",
        phone:"01457866223",
        mail:"abc@gmail.com"
    },
    {
        name:"Amir Hanja Fahim",
        img:"./assets/images/dashboards/adminDashboard/HR/applicant_three.png",
        appliedfor:"Applied for UI/UX Designer",
        phone:"01457866223",
        mail:"abc@gmail.com"
    },
    {
        name:"Amir Hanja Fahim",
        img:"./assets/images/dashboards/adminDashboard/HR/applicant_three.png",
        appliedfor:"Applied for UI/UX Designer",
        phone:"01457866223",
        mail:"abc@gmail.com"
    },
    {
        name:"Amir Hanja Fahim",
        img:"./assets/images/dashboards/adminDashboard/HR/applicant_three.png",
        appliedfor:"Applied for UI/UX Designer",
        phone:"01457866223",
        mail:"abc@gmail.com"
    },
    {
        name:"Amir Hanja Fahim",
        img:"./assets/images/dashboards/adminDashboard/HR/applicant_three.png",
        appliedfor:"Applied for UI/UX Designer",
        phone:"01457866223",
        mail:"abc@gmail.com"
    },
    {
        name:"Amir Hanja Fahim",
        img:"./assets/images/dashboards/adminDashboard/HR/applicant_three.png",
        appliedfor:"Applied for UI/UX Designer",
        phone:"01457866223",
        mail:"abc@gmail.com"
    },
    {
        name:"Amir Hanja Fahim",
        img:"./assets/images/dashboards/adminDashboard/HR/applicant_three.png",
        appliedfor:"Applied for UI/UX Designer",
        phone:"01457866223",
        mail:"abc@gmail.com"
    },
]